export const METAMASK = "metamask";
export const WALLETCONNECT = "walletconnect";
